import { useHead } from '#imports'
import type { Ref } from 'vue'

import type { ArticlePageContent } from '@backmarket/http-api/src/api-specs-content/models/article-page-content'

import { buildHead } from '~/scopes/cms/composables/useCMSHead'
import { useAddCanonicalLink } from '~/scopes/seo/composables/useAddCanonicalLink'

import { useArticlePageStructuredData } from './useArticleStructuredData'

export const CATEGORY_META_TAG = 'og:article:section'
export const IMAGE_ALT_META_TAG = 'og:image:alt'

export function useArticleHead(article: Ref<ArticlePageContent | null>) {
  useArticlePageStructuredData(article)

  if (!article.value) return

  const head = buildHead(article)
  const lastCategory = article.value.categories?.slice(-1)[0]
  const categoryName = lastCategory.name

  // Create additional meta tags for Open Graph
  const additionalMeta = []

  if (article.value.meta.image.alt) {
    additionalMeta.push({
      key: IMAGE_ALT_META_TAG,
      property: IMAGE_ALT_META_TAG,
      content: article.value.meta.image.alt,
    })
  }

  if (categoryName) {
    additionalMeta.push({
      key: CATEGORY_META_TAG,
      property: CATEGORY_META_TAG,
      content: categoryName,
    })
  }

  useHead({
    title: head.title,
    titleTemplate: head.titleTemplate,
    meta: [...head.meta, ...additionalMeta],
    link: head.link,
  })

  useAddCanonicalLink()
}
